module.exports = __webpack_public_path__ + "static/hero-product-b1f7b5de329f8dbb8f28389ffb87f405.png";